import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { useEffect, useState, useCallback } from 'react';
import currency from 'currency.js';
import AlertConfirmModal from '../../common/AlertConfirmModal';
const isCurrency = require('is-currency');
import debounce from 'lodash/debounce';
import { useToasts } from 'react-toast-notifications';
import SendPayment from '../../common/SendPayment';
import { exportCSVFile } from '../../utils/helper';
import moment from 'moment';
import Chargeback from '../../common/Chargeback';
import InputMask from 'react-input-mask';

import './style.scss';
import BalancePayment from '../../common/BalancePayment';

const PuPayout = () => {
    const { addToast } = useToasts();

    const [date, setDate] = useState('');
    const [username, setUsername] = useState('');
    const [isPaypal, setIsPaypal] = useState(true);
    const [isBank, setIsBank] = useState(true);
    const [isNone, setIsNone] = useState(true);
    const [exchangeRate, setExchangeRate] = useState(0);
    const [isGettingExhangeRate, setisGettingExhangeRate] = useState(false);
    const [payouts, setPayouts] = useState([]);
    const [isGettingPayout, setIsGettingPayout] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [show, setShow] = useState(false);
    const [page, setPage] = useState(1);
    const [showPayment, setShowPayment] = useState(false);
    const [activeUser, setActiveUser] = useState({});
    const [isGeneratingBank, setIsGeneratingBank] = useState(false);
    const [isGeneratingPaypal, setIsGeneratingPaypal] = useState(false);
    const [isBalanceOwing, setIsBalanceOwing] = useState(true);
    const [balanceOwing, setBalanceOwing] = useState(50);
    const [filterPayoutVerified, setFilterPayoutVerified] = useState(true);
    const [filterActiveStatus, setFilterActiveStatus] = useState(true);
    const [filterSuspended, setFilterSuspended] = useState(false);
    const [allMonthsFrom, setAllMonthsFrom] = useState(false);
    const [showBalPayment, setShowBalPayment] = useState(false);

    const perPage = 1;

    const handleSubmit = (e) => {
        e.preventDefault();
        getExchangeRate();
        getPayouts();
    };

    const getPayouts = () => {
        setIsGettingPayout(true);
        axios.get('/api/administration/pu-payouts', {
            params: {
                date,
                username,
                paypal: isPaypal,
                bank: isBank,
                none: isNone,
                per_page: perPage,
                page: page,
                isBalanceOwing,
                balanceOwing,
                filter_payout_verified: filterPayoutVerified,
                filter_active_status: filterActiveStatus,
                filter_suspended: filterSuspended,
                all_months_from: allMonthsFrom,
            }
        })
            .then(response => {
                setPayouts(response.data);
            })
            .catch(error => {
                addToast('Unable to get PU payout list', { appearance: 'error', autoDismiss: true });
            })
            .finally(() => {
                setIsGettingPayout(false);
            });
    };

    const getExchangeRate = () => {
        setisGettingExhangeRate(true);
        axios.get('/api/administration/exchange-rate', {
            params: {
                date
            }
        })
            .then(response => {
                setExchangeRate(response.data.exchangeRate);
            })
            .catch(error => {
                addToast('Unable to get exchange rate', { appearance: 'error', autoDismiss: true });
            })
            .finally(() => {
                setisGettingExhangeRate(false);
            });
    };

    useEffect(() => {
        getExchangeRate();
    }, []);

    useEffect(() => {
        if (alertText) {
            setShow(true);
        }
    }, [alertText]);

    useEffect(() => {
        if (!show) {
            setAlertText('');
        }
    }, [show]);

    const handlePayoutChange = (e, index) => {
        if (!payouts[index].to_update) {
            setAlertText('Please select row before update');
            return;
        }
        payouts[index].pay_type = e.target.value;

        setPayouts([...payouts]);
    };

    const handleCStatus = (e, index) => {
        if (!payouts[index].to_update) {
            setAlertText('Please select row before update');
            return;
        }
        payouts[index].c_status = e.target.value;

        setPayouts([...payouts]);
    };

    const handleNotesChange = (e, index) => {
        payouts[index].pu_notes = e.target.value;
        setPayouts([...payouts]);
    };

    const forceSelectRow = (e, index) => {
        payouts[index].to_update = true;
        setPayouts([...payouts]);
    };

    const handleSelectRow = (e, index) => {
        payouts[index].to_update = !payouts[index].to_update;
        setPayouts([...payouts]);
    };

    const handleUpdate = () => {
        const payload = [];
        payouts.forEach(payout => {
            if (payout.to_update) {
                payload.push(payout);
            }
        });

        console.log({ payload });

        axios.patch('/api/administration/pu-payouts', {
            payouts: payload
        })
            .then(res => {
                console.log(res);
                addToast('PU payout details updated', { appearance: 'success', autoDismiss: true });
            })
            .catch(err => {
                console.error(err);
                addToast('Unable to update payout', { appearance: 'error', autoDismiss: true });
            });
    };

    const handlePayoutCurrency = (e, index) => {
        if (!payouts[index].to_update) {
            setAlertText('Please select row before update');
            return;
        } else {
            payouts[index].payout_currency = e.target.value;
            setPayouts([...payouts]);
            debounce(handlePayoutBlur, 1000)(e, index);
        }
    };

    const debounceCurrency = useCallback(async (e, index) => {
        e.persist();
        handlePayoutCurrency(e, index);
    });

    const handlePaypalEmail = (e, index) => {
        if (!payouts[index].to_update) {
            setAlertText('Please select row before update');
            return;
        }
        payouts[index].paypal_email = e.target.value;
        setPayouts([...payouts]);
    };

    const handleBankBSB = (e, index) => {
        if (!payouts[index].to_update) {
            setAlertText('Please select row before update');
            return;
        }
        payouts[index].bsb_number = e.target.value;
        setPayouts([...payouts]);
    };

    const handleAccountNumber = (e, index) => {
        if (!payouts[index].to_update) {
            setAlertText('Please select row before update');
            return;
        }
        payouts[index].account_number = e.target.value;
        setPayouts([...payouts]);
    };

    const handleAccountName = (e, index) => {
        if (!payouts[index].to_update) {
            setAlertText('Please select row before update');
            return;
        }
        payouts[index].account_name = e.target.value;
        setPayouts([...payouts]);
    };

    const handlePayoutBlur = (e, index) => {
        if (!isAcceptableCurrency(e.target.value)) {
            setAlertText('Please use AUD or USD currency');
            payouts[index].payout_currency = '';
            setPayouts([...payouts]);
            return;
        }
    };

    function isAcceptableCurrency(value) {
        const acceptableCurrency = ['USD', 'AUD'];
        return acceptableCurrency.includes(value.toUpperCase());
    }

    const handlePayment = (e) => {
        e.preventDefault();
        const selected = payouts.filter((payout) => payout.to_update);

        if (selected.length > 1) {
            setAlertText('Multiple selection not allowed');
            return;
        }
        if (selected.length == 0) {
            setAlertText('Please select a PU');
            return;
        }

        setShowPayment(true);
        setActiveUser(selected[0]);
    };

    const handleBalPayment = () => {
        const selected = payouts.filter((payout) => payout.to_update);

        if (selected.length > 1) {
            setAlertText('Multiple selection not allowed');
            return;
        }
        if (selected.length == 0) {
            setAlertText('Please select a PU');
            return;
        }

        setShowBalPayment(true);
        setActiveUser(selected[0]);
    };

    const handleSuccess = () => {
        setShowPayment(false);
        getPayouts();
    };

    const handleBalanceSuccess = () => {
        setShowBalPayment(false);
        getPayouts();
    };

    const handlePayoutVerified = (e, index) => {
        if (!payouts[index].to_update) {
            setAlertText('Please select row before update');
            return;
        }
        payouts[index].payout_verified = !payouts[index].payout_verified;
        setPayouts([...payouts]);
    };

    const handleClear = () => {
        setUsername('');
        setDate('');
        setPayouts([]);
    };

    const handleDownloadBankCSV = async () => {
        setIsGeneratingBank(true);
        await axios.get('/api/administration/pu-payouts/export', {
            params: {
                filter: 'BANK',
                date,
                username,
                paypal: isPaypal,
                bank: isBank,
                none: isNone,
                isBalanceOwing,
                balanceOwing,
                filter_payout_verified: filterPayoutVerified,
                filter_active_status: filterActiveStatus,
                filter_suspended: filterSuspended,
                all_months_from: allMonthsFrom,
            }
        })
            .then(response => {
                const headers = {
                    username: "Username",
                    account_name: "Account Name",
                    account_number: "Account Number",
                    bsb_number: "BSB Number",
                    balance_owning: 'Balance Owning'
                };

                if (!date) {
                    date = moment().format('MM/YYYY');
                }

                let dateName = date.split('/');

                exportCSVFile(
                    headers,
                    response.data,
                    `BankExport-${dateName[1]}-${dateName[0]}(${moment().format('YYYY-MM-DD HHmm')})`
                );
            })
            .catch(error => {

            })
            .finally(() => {
                setIsGeneratingBank(false);
            });
    };

    const handleDownloadPaypalCSV = async () => {
        setIsGeneratingPaypal(true);
        await axios.get('/api/administration/pu-payouts/export', {
            params: {
                filter: 'PAYPAL',
                date,
                username,
                paypal: isPaypal,
                bank: isBank,
                none: isNone,
                isBalanceOwing,
                balanceOwing,
                filter_payout_verified: filterPayoutVerified,
                filter_active_status: filterActiveStatus,
                filter_suspended: filterSuspended,
                all_months_from: allMonthsFrom,
            }
        })
            .then(response => {
                const headers = {
                    paypal_email: "Email",
                    balance_owing: 'Balance Owing',
                    currency: "Currency",
                    user_id: "User ID",
                    username: "Username",
                };

                if (!date) {
                    date = moment().format('MM/YYYY');
                }

                let dateName = date.split('/');

                exportCSVFile(
                    headers,
                    response.data,
                    `PaypalExport-${dateName[1]}-${dateName[0]}(${moment().format('YYYY-MM-DD HHmm')})`
                );
            })
            .catch(error => {

            })
            .finally(() => {
                setIsGeneratingPaypal(false);
            });
    };

    const [showChargeBack, setShowChargeBack] = useState(false);
    const handleChargeBack = (e) => {
        e.preventDefault();
        const selected = payouts.filter((payout) => payout.to_update);

        if (selected.length > 1) {
            setAlertText('Multiple selection not allowed');
            return;
        }

        if (selected.length == 0) {
            setAlertText('Please select a PU');
            return;
        }
        setActiveUser(selected[0]);
        setShowChargeBack(showChargeBack => !showChargeBack);
    };

    const clearUsernameSearchText = () => {
        setUsername('');
    };

    return <div className="mt-2 pu-payout">
        <AlertConfirmModal
            modalBody={alertText}
            show={show}
            setShow={setShow}
            isConfirm={false} />
        <h3 className="mb-4">PU Payout</h3>
        <Form onSubmit={handleSubmit} inline>
            <Form.Group>
                <Form.Label htmlFor="username">
                    Username
                </Form.Label>
                <Form.Control
                    className="form-control mb-2 mr-sm-2"
                    id="username"
                    placeholder=""
                    custom
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                {
                    username && <i className="fal fa-times search-clear-icon" onClick={clearUsernameSearchText} />
                }
            </Form.Group>

            <Form.Group>
                <Form.Label htmlFor="monthYear">
                    Month/Year
                </Form.Label>
                <InputMask
                    mask="99/9999"
                    className="form-control mb-2 mr-sm-2"
                    id="date"
                    name="date"
                    placeholder="MM/YYYY"
                    value={date}
                    onChange={(e) => { setDate(e.target.value); }}
                />
            </Form.Group>

            <Form.Check
                inline
                label="All months from/incl."
                name="all_months_from"
                type="checkbox"
                id="all_months_from"
                onChange={() => setAllMonthsFrom(!allMonthsFrom)}
                checked={allMonthsFrom}
            />


            <div className="buttons-container">
                <Button type="submit" className="" onClick={handleSubmit} disabled={isGettingPayout}>
                    {isGettingPayout ? 'Getting list' : 'List Refresh'}
                </Button>
                <Button type="button" className="" onClick={handleClear}>
                    Clear
                </Button>
            </div>
        </Form>

        <div className="mt-2">
            <Row>
                <Col>Exchange Rate For Month: <span
                    className="py-1 px-2 mr-4"
                    style={{
                        backgroundColor: '#ecf0f1',
                        borderRadius: '3px'
                    }}
                >
                    {
                        isGettingExhangeRate
                            ? <Spinner size="sm" animation="border" variant="primary" />
                            : currency(exchangeRate, { symbol: '', precision: 10 }).format()
                    }
                </span>

                    <span className="mr-2">Filter:</span>

                    <Form.Check
                        inline
                        label="Payout Verified"
                        name="payout_verified"
                        type="checkbox"
                        id="payout_verified"
                        onChange={() => setFilterPayoutVerified(!filterPayoutVerified)}
                        checked={filterPayoutVerified}
                    />
                    <Form.Check
                        inline
                        label="Active Status"
                        name="active_status"
                        type="checkbox"
                        id="active_status"
                        onChange={() => setFilterActiveStatus(!filterActiveStatus)}
                        checked={filterActiveStatus}
                    />
                    <Form.Check
                        inline
                        label="Suspended"
                        name="filterSuspended"
                        type="checkbox"
                        id="filterSuspended"
                        onChange={() => setFilterSuspended(!filterSuspended)}
                        checked={filterSuspended}
                    />


                    <span className="mr-2">Pay Type:</span>
                    <Form.Check
                        inline
                        label="Bank"
                        name="bank"
                        type="checkbox"
                        id="bank"
                        onChange={() => setIsBank(!isBank)}
                        checked={isBank}
                    />
                    <Form.Check
                        inline
                        label="Paypal"
                        name="paypal"
                        type="checkbox"
                        id="paypal"
                        onChange={() => setIsPaypal(!isPaypal)}
                        checked={isPaypal}
                    />
                    <Form.Check
                        inline
                        label="None"
                        name="none"
                        type="checkbox"
                        id="none"
                        onChange={() => setIsNone(!isNone)}
                        checked={isNone}
                    />

                    {/* <Form.Check
            inline
            label="Balance Owing"
            name="isBalanceOwing"
            type="checkbox"
            id="isBalanceOwing"
            onChange={() => setIsBalanceOwing(! balanceOwing)}
            checked={balanceOwing}
            className="ml-4"
          /> */}
                    <Form.Check
                        className="ml-4"
                        id="isBalanceOwing"
                        inline
                    >
                        <Form.Check.Label className="mr-1">
                            Balance Owing
                        </Form.Check.Label>
                        <Form.Check.Input
                            type="checkbox"
                            onChange={() => setIsBalanceOwing(!isBalanceOwing)}
                            checked={isBalanceOwing}
                            name="isBalanceOwing"
                        />
                    </Form.Check>

                    <div className="form-check-inline"> {'>'} USD <Form.Control
                        size="sm"
                        type="number"
                        placeholder=""
                        value={balanceOwing}
                        onChange={e => setBalanceOwing(e.target.value)}
                        className="col-4 mx-1"
                    />
                    </div>
                </Col>
            </Row>
        </div>

        <div className="mt-4">
            <div className="my-4 p-0 button-container">
                <Button
                    type="button"
                    onClick={handleUpdate}
                    className='mr-2'
                >
                    Update
                </Button>

                <Button type="button" className=" ml-4" onClick={handlePayment}>
                    Add Early Payment
                </Button>

                <Button type="button" className="" onClick={handleBalPayment}>
                    Add Bal Payment
                </Button>

                <Button type="button" className="" onClick={handleChargeBack}>
                    Add Charge Back
                </Button>

                <Button type="button" className=" ml-4" onClick={handleDownloadBankCSV} disabled={isGeneratingBank}>
                    Bank Export
                </Button>
                <Button type="button" className="" onClick={handleDownloadPaypalCSV} disabled={isGeneratingPaypal}>
                    Paypal Export
                </Button>
            </div>
            <Table striped hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Username</th>
                        <th>Ver</th>
                        <th>Status</th>
                        <th>Pay Type</th>
                        <th>Pay Curr</th>
                        <th>Notes</th>
                        <th>Paypal Email</th>
                        <th>Bank BSB</th>
                        <th>Account #.</th>
                        <th>Account Name</th>
                        <th>Last<br />Payout<br />Date</th>
                        <th>Last<br />Payout<br />Amount</th>
                        <th>Month Total</th>
                        <th>Earned</th>
                        <th>Chargeback</th>
                        <th>Balance<br />Owing<br />USD</th>
                        <th>Balance<br />Owing<br />AUD</th>
                        <th>AUD/USD</th>
                        <th>Balance<br />Paid<br />Date</th>
                        <th>Paid<br />Ref</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        payouts.map((payout, index) => {
                            return <tr key={payout.id} onClick={(e) => forceSelectRow(e, index)}>
                                <td onClick={e => e.stopPropagation()}>
                                    <input
                                        type="checkbox"
                                        onChange={(e) => handleSelectRow(e, index)}
                                        checked={payout.to_update}
                                    />
                                </td>
                                <td>
                                    {payout.username}
                                </td>
                                <td>
                                    <input
                                        type="checkbox"
                                        onChange={(e) => handlePayoutVerified(e, index)}
                                        checked={payout.payout_verified}
                                    />
                                </td>
                                <td>
                                    <select
                                        value={payout.c_status || 'active'}
                                        onChange={(e) => handleCStatus(e, index)}
                                        style={{
                                            padding: '3px',
                                            width: '60px'
                                        }}
                                    >
                                        <option value="active">Active</option>
                                        <option value="inactive">In-active</option>
                                        <option value="suspended">Suspended</option>
                                    </select>
                                </td>
                                <td>
                                    <select
                                        value={payout.pay_type || '0'}
                                        onChange={(e) => handlePayoutChange(e, index)}
                                        style={{
                                            padding: '3px',
                                            width: '60px'
                                        }}
                                    >
                                        <option value="0">None</option>
                                        <option value="1">Paypal</option>
                                        <option value="2">Bank</option>
                                    </select>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        value={payout.payout_currency || ''}
                                        onChange={(e) => debounceCurrency(e, index)}
                                        style={{
                                            textTransform: 'uppercase',
                                            width: '34px',
                                            border: '1px solid #ccc'
                                        }}
                                        maxLength="3"
                                        minLength="2"
                                        size="8"
                                    />
                                </td>
                                <td>
                                    <textarea
                                        value={payout.pu_notes}
                                        onChange={(e) => handleNotesChange(e, index)}
                                        style={{ fontSize: '10px', padding: '3px' }}
                                        rows={1}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="email"
                                        value={payout.paypal_email || ''}
                                        onChange={(e) => handlePaypalEmail(e, index)}
                                        disabled={payout.pay_type == 0 || payout.pay_type == 2}
                                        style={{
                                            border: '1px solid #ccc'
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        value={payout.bsb_number || ''}
                                        onChange={(e) => handleBankBSB(e, index)}
                                        disabled={payout.pay_type == 0 || payout.pay_type == 1}
                                        style={{
                                            width: '75px',
                                            border: '1px solid #ccc'
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        value={payout.account_number || ''}
                                        onChange={(e) => handleAccountNumber(e, index)}
                                        disabled={payout.pay_type == 0 || payout.pay_type == 1}
                                        style={{
                                            width: '75px',
                                            border: '1px solid #ccc'
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        value={payout.account_name || ''}
                                        onChange={(e) => handleAccountName(e, index)}
                                        disabled={payout.pay_type == 0 || payout.pay_type == 1}
                                        style={{
                                            border: '1px solid #ccc'
                                        }}
                                    />
                                </td>
                                <td>
                                    {payout.last_payout_date}
                                </td>
                                <td>
                                    {currency(payout.amount).format()}
                                </td>
                                <td>
                                    {currency(payout.sum).format()}
                                </td>
                                <td>
                                    {currency(payout.earned).format()}
                                </td>
                                <td>
                                    {currency(payout.chargeback).format()}
                                </td>
                                <td>
                                    {currency(payout.balance_owning_usd).format()}
                                </td>
                                <td>
                                    {currency(payout.balance_owning_aud).format()}
                                </td>
                                <td>
                                    {payout.balance_owning_rate}
                                </td>
                                <td>
                                    {payout.monthly_paid_date}
                                </td>
                                <td>
                                    {payout.monthly_paid_ref}
                                </td>
                            </tr>;
                        })
                    }
                    {
                        payouts.length <= 0 && <tr>
                            <td colSpan="21">
                                {
                                    isGettingPayout
                                        ? <Spinner
                                            variant="primary"
                                            animation="border"
                                            size="sm"
                                        />
                                        : 'No data found'
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </Table>
        </div>
        <SendPayment
            show={showPayment}
            setShow={setShowPayment}
            activeUser={activeUser}
            handleSuccess={handleSuccess}
        />
        <BalancePayment
            show={showBalPayment}
            setShow={setShowBalPayment}
            activeUser={activeUser}
            handleSuccess={handleBalanceSuccess}
        />
        <Chargeback
            show={showChargeBack}
            setShow={setShowChargeBack}
            activeUser={activeUser}
            handleSuccess={handleSuccess}
        />
    </div >;
};

export default PuPayout;
